
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getCongressionalDistrictsByStateAndPlace",
      resolverType: "query",
      routePath: "/getCongressionalDistrictsByStateAndPlace",
      httpMethod: "POST",
    });
  